<template>
  <div id="app">
    <div class="page-container" v-if="showBody">
      <md-app>
        <md-app-toolbar class="md-transparent" v-if="showAppToolbar">
          <md-button
            class="md-icon-button"
            @click="toggleMenu"
            v-if="!menuVisible"
          >
            <md-icon>menu</md-icon>
          </md-button>
          <md-button
            class="md-icon-button"
            @click="goBack()"
            :disabled="noMoreBack"
          >
            <md-icon>undo</md-icon>
            <md-tooltip md-direction="bottom">Back</md-tooltip>
          </md-button>
          <b-row v-if="currentRoute == 'propertyCalendar'">
            <b-col cols="10" md="6">
              <md-field class="md-toolbar-section-end">
                <label for="order">Order by</label>
                <md-select
                  v-model="currentOrder"
                  name="order"
                  id="order"
                  :md-selected="
                    actionToolbarCTAAction({
                      trigger: 'changeOrder',
                      input: currentOrder,
                    })
                  "
                >
                  <md-option value="address">Address</md-option>
                  <md-option value="vacancy">Vacancy</md-option>
                </md-select>
              </md-field>
            </b-col>
            <b-col cols="10" md="6">
              <md-field
                md-clearable
                class="properties-filter-input"
                @md-clear="propertiesFilter = ''"
              >
                <label>Filter by</label>
                <md-input
                  v-model="propertiesFilter"
                  @input="
                    actionToolbarCTAAction({
                      trigger: 'changeFilter',
                      input: propertiesFilter,
                    })
                  "
                  placeholder="Start typing to filter properties..."
                ></md-input>
              </md-field>
            </b-col>
          </b-row>
          <span v-else-if="viewTitleForced" class="md-title">{{
            viewTitleForced
          }}</span>
          <span v-else class="md-title">{{ currentViewTitle }}</span>
          <div class="md-toolbar-section-end">
            <md-menu md-direction="bottom-start">
              <md-badge
                md-content="!"
                md-dense
                :class="{ 'moow-badge': showUnreadMsgBadge }"
              >
                <md-button class="md-icon-button" md-menu-trigger>
                  <md-icon>notification_important</md-icon>
                </md-button>
              </md-badge>
              <md-menu-content v-if="showUnreadMsgBadge">
                <md-menu-item @click="goForward({ where: 'chat' })"
                  >New Messages</md-menu-item
                >
              </md-menu-content>
            </md-menu>

            <md-menu md-direction="bottom-start" v-if="loggedIn" class="ml-3">
              <moow-avatar
                md-menu-trigger
                :imgSource="userAvatar"
                :badge="!userEmailIsVerified"
              ></moow-avatar>
              <md-menu-content class="user-pop-menu">
                <md-list>
                  <md-list-item @click="goForward({ where: 'settings' })">
                    <md-icon>account_circle</md-icon>
                    <span class="md-list-item-text">Profile</span>
                  </md-list-item>
                  <md-list-item @click="goForward({ where: 'account' })">
                    <md-icon>settings</md-icon>
                    <span class="md-list-item-text">Account</span>
                  </md-list-item>
                  <md-list-item @click="logOut()" >
                    <md-icon>power_settings_new</md-icon>
                    <span class="md-list-item-text">Log out</span>
                  </md-list-item>
                </md-list>
                <md-menu-item
                  @click="goForward({ where: 'settings' })"
                  v-if="!userEmailIsVerified"
                  class="alert-menu-item"
                >
                  <strong>Confirm email</strong>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </md-app-toolbar>

        <md-app-drawer
          :md-active.sync="menuVisible"
          md-persistent="full"
          class="play-drawer dark"
          v-if="showAppToolbar"
        >
          <md-toolbar class="md-transparent" md-elevation="0">
            <div
              class="main-logo-holder"
              @click="goForward({ where: 'dashboard' })"
            ></div>

            <div class="md-toolbar-section-end">
              <md-button class="md-icon-button md-dense" @click="toggleMenu">
                <md-icon>keyboard_arrow_left</md-icon>
              </md-button>
            </div>
          </md-toolbar>

          <md-list class="md-transparent mt-5 white-list">
            <md-list-item
              @click="goForward({ where: 'dashboard' })"
              v-if="loggedIn && userViewRoleIsLandlord"
              :class="{ 'selected-list-item': selected('dashboard') }"
            >
              <md-icon>description</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.properties | allCaps
              }}</span>
            </md-list-item>

            <md-list-item
              @click="goForward({ where: 'deals' })"
              v-if="loggedIn && userViewRoleIsLandlord"
              :class="{ 'selected-list-item': selected('deals') }"
            >
              <md-icon>bookmarks</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.deals | allCaps
              }}</span>
              <md-tooltip md-direction="bottom">for landlords</md-tooltip>
            </md-list-item>

            <md-list-item
              @click="goForward({ where: 'stays' })"
              v-if="loggedIn && !userViewRoleIsLandlord"
              :class="{ 'selected-list-item': selected('stays') }"
            >
              <md-icon>place</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.stays | allCaps
              }}</span>
              <md-tooltip md-direction="bottom">for tenants</md-tooltip>
            </md-list-item>

            <md-list-item
              @click="goForward({ where: 'propertyCalendar' })"
              v-if="loggedIn && userViewRoleIsLandlord"
              :class="{ 'selected-list-item': selected('propertyCalendar') }"
            >
              <md-icon>calendar_today</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.calendar | allCaps
              }}</span>
            </md-list-item>

            <md-list-item
              @click="goForward({ where: 'chat' })"
              v-if="loggedIn"
              :class="{ 'selected-list-item': selected('chat') }"
            >
              <md-icon>chat</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.chat | allCaps
              }}</span>
              <md-badge
                class="md-square"
                md-content="New"
                v-if="showUnreadMsgBadge"
              />
            </md-list-item>

            <md-list-item
              @click="goForward({ where: 'pricePrediction' })"
              :class="{ 'selected-list-item': selected('pricePrediction') }"
            >
              <md-icon>monetization_on</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.valuation_engine | allCaps
              }}</span>
            </md-list-item>

            <md-list-item to="/login" v-if="!loggedIn">
              <md-icon>power_settings_new</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.log_in | allCaps
              }}</span>
            </md-list-item>

            <md-list-item to="/register" v-if="!loggedIn">
              <md-icon>account_circle</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.sign_up | allCaps
              }}</span>
            </md-list-item>

            <md-divider class="play-divider"></md-divider>

            <md-list-item @click="openMarketplace()">
              <md-icon>apartment</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.market | capitalize
              }}</span>
              <md-icon>open_in_new</md-icon>
            </md-list-item>

            <md-list-item @click="logOut()" v-if="loggedIn">
              <md-icon>power_settings_new</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.log_out | capitalize
              }}</span>
            </md-list-item>

            <md-list-item @click="showContactForm = true">
              <md-icon>contact_support</md-icon>
              <span class="md-list-item-text">{{
                i18n_local.support | capitalize
              }}</span>
            </md-list-item>

            <md-list-item>
              <md-icon>translate</md-icon>
              <md-field>
                <label for="language" style="color: white">Language</label>
                <md-select
                  v-model="selectedLanguage"
                  name="language"
                  id="language"
                  @md-selected="selectLanguage"
                >
                  <md-option value="et-NL">Eesti</md-option>
                  <md-option value="en-NL">English</md-option>
                  <md-option value="ru-NL">Pусский</md-option>
                </md-select>
              </md-field>
            </md-list-item>
          </md-list>

          <div
            class="view-role-container mt-2"
            :class="{ hidden: !menuVisible }"
            v-if="loggedIn"
          >
            <p style="margin-left: 1em">{{ i18n_local.your_role }}</p>
            <toggle-switch
              :btnTitleOn="i18n_local.im_landlord"
              :btnTitleOff="i18n_local.im_tenant"
              @emitToggleOn="toggleUserViewRole"
              :initialState="userViewRoleIsLandlord"
            />
          </div>
          <p id="version-code">v2.1.0</p>
        </md-app-drawer>

        <md-app-content
          class="play-background"
          :class="{
            'no-padding': !showAppToolbar,
            'play-background-moow': selected('chat'),
          }"
        >
          <router-view
            name="content"
            @emitToggleHelpDialog="toggleHelpDialog"
            @emitToggleSupportChat="toggleSupportChat"
            @emitChangeViewTitle="changeViewTitle"
            @emitGoForward="goForward"
            @emitCustomAction="handleCustomAction"
            :bus="bus"
          ></router-view>
          <moow-footer-mini v-if="showFooter"></moow-footer-mini>
        </md-app-content>
      </md-app>
    </div>
    <moow-full-loader v-else />

    <moow-dialog-confirm
      :title="helpDialogTitle"
      :content="helpDialogMessage"
      confirmText="OK"
      cancelText="Close"
      :showDialog="showHelpDialog"
      @mConfirm="showHelpDialog = false"
      @mCancel="showHelpDialog = false"
    />

    <md-dialog :md-active.sync="showContactForm">
      <contact-form @closeForm="showContactForm = false"></contact-form>
    </md-dialog>

    <snackbar
      style="z-index: 99999"
      message="Connection lost, progress not saving"
      :duration="Number(40000)"
      :showSnackbar="!connected"
      position="center"
      :isInfinity="true"
    ></snackbar>

    <nps-snackbar
      style="z-index: 99999"
      message="How likely would you be to recommend Moowle?"
      :duration="Number(40000)"
      :showSnackbar="askNps"
      position="left"
      :isInfinity="true"
    ></nps-snackbar>

    <moow-notification :title="notificationTitle" :content="notificationContent" v-if="showNotification"></moow-notification>

    <md-snackbar :md-duration="Infinity" md-persistent :md-active.sync="showTutorialSnackbar">
      <span>{{tutorialMessage}}</span>
      <div>
        <moow-button :type="['light', 'flat', 'outlined']" btnText="OK" @mClick="closeTutorial"/>
      </div>
    </md-snackbar>
  </div>
</template>

<script>
import Snackbar from "@/components/snackbar.vue";
import NpsSnackbar from "@/components/npsSnackbar.vue";
import FooterMini from "@/components/footer/FooterMini.vue";
import FullLoader from "@/components/utils/FullLoader.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import ContactUsForm from "@/components/dialogs/ContactUsForm.vue";
import SupportForm from "@/components/dialogs/SupportForm";
import AddressSearchBar from "@/components/adrSearchBar.vue";
import ToggleSwitch from "@/components/interface/buttons/toggleSwitch.vue";
import  {showTutorial, hideTutorial} from '@/platform/utils/tutorial/index.js'

var lodash = require("lodash/function");

export default {
  name: "app",
  components: {
    snackbar: Snackbar,
    "nps-snackbar": NpsSnackbar,
    "moow-footer-mini": FooterMini,
    "moow-full-loader": FullLoader,
    "contact-form": ContactUsForm,
    "adr-search-bar": AddressSearchBar,
    "support-form": SupportForm,
    "toggle-switch": ToggleSwitch,
  },
  data() {
    return {
      showContactForm: false,
      selectedLanguage: "",
      menuVisible: true,
      footerBlacklist: ["chat", "propertyCalendar"],
      showFeedback: false,
      snackbarMessage: "",
      showSnackbar: false,
      showHelpDialog: false,
      showSupportChat: true,
      helpDialogTitle: "Help",
      helpDialogMessage: "This is a help dialog",
      bus: new Vue(),
      currentOrder: "",
      propertiesFilter: "",
      viewTitleForced: "",
      showNotification: false,
      notificationContent: "",
      notificationTitle: ""
    };
  },
  created() {
    this.selectedLanguage = this.selectedLocale;

    window.addEventListener("offline", this.handleOffline);
    window.addEventListener("online", this.handleOnline);

    // This is used to handle cross page/tab messages.
    // window.addEventListener("message", this.receiveMessage, false);

    this.defaultLocale();
    this.backstack.push("dashboard");

    let uvr = localStorage.getItem("user_view_role")
    console.log('uvr:', uvr);
    
    if(uvr === "landlord") this.setUserViewRole(true)
    else if(uvr === "tenant") this.setUserViewRole(false)
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    allCaps: function (value) {
      if (!value) return "";
      return value.toUpperCase();
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    // showTutorialSnackbar(){
    //   return this.$store.getters.showTutorial
    // },
    showTutorialSnackbar: {
        get(){
          return this.$store.getters.showTutorial
        },
        set(newName){
          return // do nothing, needed to avoid runtime error
        } 
    },
    tutorialMessage(){
      return this.$store.getters.tutorialMessage
    },
    showAppToolbar() {
      console.log('this.currentRoute:', this.currentRoute);
      
      if (this.currentRoute == "pricePrediction" || this.currentRoute == "listingsearch") return false
      if (!this.loggedIn || this.currentRoute == "listing") return false;
      else return true;
    },
    currentViewTitle() {
      if (this.currentRoute == "dashboard") return "My Properties";
      if (this.currentRoute == "chat") return "Messenger";
      if (this.currentRoute == "deals") return "My Deals";
      if (this.currentRoute == "propertyCalendar") return "My Calendar";
      if (this.currentRoute == "stays") return "My Stays";
      return "";
    },
    currentRoute() {
      return this.$route.name;
    },
    accountInitiated() {
      return this.$store.getters.accountInitiated;
    },
    userViewRole() {
      return this.$store.getters.userViewRole;
    },
    loggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    askNps() {
      return this.$store.getters.askNps;
    },
    showFooter() {
      return !this.footerBlacklist.includes(this.currentRoute);
    },
    showBody() {
      return (
        !this.loggedIn ||
        this.currentRoute == "listing" ||
        this.accountInitiated
      ); // Only route we don't need accountId is Preview
    },
    connected() {
      return this.$store.getters.connected;
    },
    notificationMessage() {
      return this.$store.getters.notificationMessage;
    },
    userAvatar() {
      if (this.$store.getters.user.pictureUrl)
        return this.$store.getters.user.pictureUrl;
      return require("./assets/owl_round_back.png");
    },
    loggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    showUnreadMsgBadge() {
      return this.$store.getters.showUnreadMsgBadge;
    },
    userEmailIsVerified(){
      return this.$store.getters.isUserEmailVerified;
    },
    userIsVerified() {
      return this.$store.getters.isUserVerified;
    },
    loadingUser() {
      return this.$store.getters.loadingUser;
    },
    userViewRoleIsLandlord() {
      return this.$store.getters.userViewRole == "landlord";
    },
    backstack() {
      return this.$store.getters.backstack;
    },
    noMoreBack() {
      return this.backstack.isEmpty() || this.backstack.isLast();
    },
  },
  watch: {
    userViewRole: function (val) {
      if (
        val === "tenant" &&
        (this.$route.name === "deals" ||
          this.$route.name === "propertyCalendar" ||
          this.$route.name === "properties")
      ) {
        this.redirectTo("stays");
        return;
      }
      if (val === "landlord" && this.$route.name === "stays") {
        this.redirectTo("stays");
        return;
      }
    },
    notificationMessage: function (val) {
      if (val) {
        this.sendUserNotification(
          this.$store.getters.notificationTitle,
          this.$store.getters.notificationMessage
        );
      }
    },
  },
  methods: {
    ...mapActions("internationalizationModule", ["defaultLocale", "setLocale"]),
    closeTutorial(){
      hideTutorial(document)
    },
    goBack(params) {
      if (this.backstack.isLast()) return;
      this.backstack.pop(); // remove current
      const view = this.backstack.peek();
      const preState = this.backstack.getPreState(view);

      var p = {};
      if (preState) {
        if (params) {
          params.preState = preState;
          p = params;
        } else p.preState = preState;
      }
      console.log("goBack | view:", view);

      view ? this.navigateTo(view, p) : void 0;

      this.changeViewTitle(""); // remove the forced view title so that views can have natural title be default
    },
    displayNotification({title, content}){
      console.log('title, content:', title, content);
      
      this.showNotification = true
      this.notificationTitle = title
      this.notificationContent = content
      this.startCountdownForNotification(5000)
    },
    hideNotification(){
      this.showNotification = false
      this.notificationTitle = ""
      this.notificationContent = ""
    },
    openMarketplace() {
      window.open("/#/market", "_blank");
    },
    goForward({ where, params, preState }) {
      if (where && where != this.currentRoute) {
        this.backstack.push(where);
      }
      if (where && where != this.currentRoute && preState)
        this.backstack.setPreState(this.currentRoute, preState);
      where ? this.navigateTo(where, params) : void 0;
    },
    handleCustomAction(payload) {
      if (payload.action === "hideSideMenu") this.toggleMenu(false);
    },
    changeViewTitle(title) {
      this.viewTitleForced = title;
    },
    actionToolbarCTAAction(payload) {
      this.bus.$emit("triggerCTA", payload);
    },
    selectLanguage(locale) {
      if (locale) this.setLocale({ locale: locale.toString() });
    },
    selected(view) {
      return this.currentRoute == view;
    },
    logOut() {
      this.navigateTo("listingsearch");
      this.$store.dispatch("logout");
    },
    setUserViewRole(isLandlord){
      var role;
      isLandlord ? (role = "landlord") : (role = "tenant");
      this.$store.dispatch("editUserViewRole", role);
    },
    toggleUserViewRole(isLandlord) {
      this.setUserViewRole(isLandlord)
      isLandlord
        ? this.goForward({ where: "dashboard" })
        : this.goForward({ where: "stays" });
    },
    sendUserNotification: lodash.debounce(function (title, message) {
      if (title && message) this.notifyUser(title, message);
      window.postMessage(message, "*");
      this.postDesktopNotification(message);
    }, 2000),
    receiveMessage(event) {
      // This is used to handle cross page/tab messages.
      // console.log("receiveMessage | event:", event);
    },
    postDesktopNotification(message) {
      var msg = "New message in Moowle: " + message;
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        return;
      }

      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        var notification = new Notification(msg);
      }

      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            var notification = new Notification(msg);
          }
        });
      }
    },
    toggleSupportChat(show) {
      try {
        this.showSupportChat = show;
        if (this.showSupportChat) {
          var hsChat = document.getElementById(
            "hubspot-messages-iframe-container"
          );
          // if hsChat is null, it has been removed (can happen during initilization)
          if (!hsChat) this.createHubspotChat();
          else {
            hsChat.style.visibility = "visible";
            window.HubSpotConversations.widget.open();
          }
        } else {
          document.getElementById(
            "hubspot-messages-iframe-container"
          ).style.visibility = "hidden";
        }
      } catch (ex) {
        console.log("APp | toggleSupportChat  > ex:", ex);
      }
    },
    toggleHelpDialog({ title, message }) {
      this.helpDialogTitle = title;
      this.helpDialogMessage = message;
      this.showHelpDialog = true;
    },
    toggleMenu(value) {
      if (value === false || value === true) this.menuVisible = value;
      else this.menuVisible = !this.menuVisible;
    },
    handleOffline() {
      this.$store.commit("SET_CONNECTED", false);
    },
    handleOnline() {
      this.$store.commit("SET_CONNECTED", true);
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    navigateTo(where, params) {
      this.$router.push({
        name: where,
        params: params,
      });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/variables.scss";
@import "./assets/styles/global.css";

.play-background-moow {
  background-color: #F1F4F8;
  // background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23fea49f' fill-opacity='0.32'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  padding-bottom: 0px;
}

.play-divider {
  background-color: #f36664 !important;
  margin-top: 2em !important;
}

.no-padding {
  padding: 0 !important;
}

.play-drawer {
  background-color: $play-dark !important;
  color: white !important;
}

.play-drawer .md-list-item {
  cursor: pointer;
}

.play-drawer ul {
  background-color: transparent !important;
}

.white-list span {
  color: white;
}
.play-drawer .md-icon {
  color: white !important;
}

.selected-list-item {
  border-left: solid 3px $old-makeup-pink;
}

.selected-list-item span {
  color: $old-makeup-pink;
}
.selected-list-item .md-icon {
  color: $old-makeup-pink !important;
}

.active {
  border: none;
}

#app {
  font-family: $font-stack;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  color: #4a4a4a;
}

iframe {
  overflow: hidden !important;
}

.beta-feedback-btn {
  top: 50vh;
  position: absolute !important;
  padding: 10px 1em 10px 1em;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  z-index: 77;
  left: -55px;
  opacity: 0.7;
}

.iframe-container {
  width: 100%;
  height: 100%;
  z-index: 998;
}

.play-steppers {
  background: transparent !important;
}

.play-steppers .md-steppers-navigation {
  background-color: white !important;
}
.play-steppers .md-steppers-wrapper {
  height: auto !important;
}

.play-tabs .md-tabs-navigation {
  background-color: $play-blue !important;
}

.play-tabs .md-tabs-navigation .md-button-content {
  color: white !important;
}

.play-tabs.dark .md-tabs-navigation {
  background-color: $play-dark !important;
}

.play-tabs.makeup .md-tabs-navigation {
  background-color: $old-makeup-pink !important;
}

.play-tabs.white .md-tabs-navigation {
  background-color: white !important;
}

.play-tabs.white .md-tabs-navigation .md-button-content {
  color: $play-blue !important;
}

.play-tabs {
  background-color: transparent !important;
}

.play-tabs .md-tabs-content {
  background-color: transparent !important;
  height: 100% !important;
}

.play-tab {
  background-color: transparent !important;
}

.play-cta-fab {
  color: $old-makeup-pink;
  background-color: $old-makeup-pink !important;
}

.play-cta-fab_flat {
  background-color: transparent !important;
}

.play-cta-button {
  background-color: $play-dark !important;
  color: white !important;
  border-radius: 10px;
  padding: 0 1em;
}

.play-cta-button.fill {
  width: 100%;
}

.play-cta-button.large {
  font-size: 20px;
}

.play-fab-flat.dark {
  background-color: transparent !important;
  color: $play-dark;
}

.play-fab.light {
  background-color: $play-blue-light !important;
}

.play-fab.dark {
  background-color: $play-dark !important;
}

.play-toolbar.makeup {
  background-color: $old-makeup-pink !important;
}

.play-toolbar.dark {
  background-color: $play-dark !important;
  color: white !important;
}
.play-cta-button.disabled {
  color: grey !important;
  border-radius: 10px !important;
  border: solid 1px grey !important;
  background-color: white !important;
  padding: 0 1em;
}

.play-cta-button-flat {
  color: $play-dark !important;
  border-radius: 10px !important;
  border: solid 1px $play-dark !important;
  background-color: white !important;
  padding: 0 1em;
}

.play-cta-button-flat.danger {
  color: $red-orange !important;
  border-radius: 10px !important;
  border: solid 1px $red-orange !important;
  background-color: white !important;
  padding: 0 1em;
}

.play-cta-button-flat.grey {
  color: grey !important;
  border: solid 1px grey !important;
}

.play-cta-button.disabled {
  color: grey !important;
  border-radius: 10px !important;
  border: solid 1px grey !important;
  background-color: white !important;
  padding: 0 1em;
}

.play-cta-button-flat.makeup {
  color: $old-makeup-pink !important;
  border: solid 1px $old-makeup-pink !important;
}

.play-cta-button.white {
  background-color: white !important;
  color: $navy-blue !important;
  border-radius: 10px;
  padding: 0 1em;
}

.play-cta-button.navy {
  background-color: $navy-blue-muted !important;
  color: white !important;
  border-radius: 10px;
  padding: 0 1em;
}

.play-cta-button.makeup {
  background-color: $old-makeup-pink !important;
  color: white !important;
  border-radius: 10px;
  padding: 0 1em;
  font-weight: 700;
}

.play-cta-button.lucid {
  background-color: #3d3d3f78 !important;
  color: white !important;
  border-radius: 10px;
  padding: 0 1em;
  font-weight: 700;
}

.play-chip.makeup {
  background-color: $old-makeup-pink !important;
  color: white !important;
}

.play-chip.light {
  background-color: white !important;
  color: darkslategrey !important;
  font-size: 14px;
  border: 1px solid $navy-blue-muted !important;
}

.play-chip.dark {
  background-color: $navy-blue-muted !important;
  color: white !important;
}

.play-cta-button.accent {
  background-color: $red-orange !important;
  color: white !important;
  border-radius: 10px;
  padding: 0 1em;
}

.feedback-container {
  width: 100% !important;
  height: 100% !important;
}
.feedback-dialog {
  max-width: 340px;
  height: 90vh;
  max-height: 100%;
  left: 170px;
}

.play-background {
  // background-color: $play-underling-blue-trans;
  background-color: #F8F8F8 !important;
}

.white-background {
  background-color: white !important;
}

.play-background.waves {
  background: url("./assets/background-waves.svg") no-repeat;
  background-color: white;
  min-height: 100vh;
  background-position: center;
  background-size: cover;
}

.main-logo-holder {
  height: 50px;
  background: url("./assets/logos/logo-main-white.svg") no-repeat;
  background-position: center;
  background-size: contain;
  cursor: pointer;
  width: 150px;
}

.color_makeup {
  color: $old-makeup-pink;
}
body::-webkit-scrollbar {
  width: 5px;
}

/* Track */
body::-webkit-scrollbar-track {
  background: #f1f1f100;
}

/* Handle */
body::-webkit-scrollbar-thumb {
  background: #fea49f94;
  border-radius: 8px;
}

/* Handle on hover */
body::-webkit-scrollbar-thumb:hover {
  background: #fea49f;
}

#version-code {
  bottom: 0;
  position: absolute;
  text-align: center;
  right: 1em;
}

/*  from infinity to max 700 and then this kicks in*/
@media (max-width: 1000px) {
}
.user-pop-menu{
  border-radius: 8px !important;
  .md-list{
    padding: 0;
  }
  .md-menu-content-container {
    border-radius: 8px !important;
  }
}

.alert-menu-item {
  background-color: $old-makeup-pink;
  strong {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue